module.exports = __webpack_public_path__ + "static/media/workplace-min.96cf8743.jpg";